import React from "react";
import ReactToExcel from "react-html-table-to-excel";
import UploadFileButton from "../../../common/buttons/uploadFileButton";
import "./buttonGroup.style.scss";

const ButtonGroup = ({
  xlsxEvent,
  securityUploadError,
  resetErrorUploadedPortfolio,
}) => {
  return (
    <div className="buttonGroup">
      <div className="buttonGroup__download" >
        <ReactToExcel
          table="universe_lite"
          filename="securite_lite"
          sheet="security_lite"
          buttonText=" 📄 Download securities"
          className="btn downButton"
        />
      </div>
      <div style={{display : " flex"}}>
        <UploadFileButton
        text="Upload securities"
        icon="fa-upload"
        iconRight={false}
        eventHandler={xlsxEvent}
        id="upload_scenario_file02"
        className = "UploadSpacing"
      />
      </div>
      
      {securityUploadError ? (
        <div className="buttonGroup__reset">
          <button
            className="btn create_reset fadeIn"
            onClick={() => resetErrorUploadedPortfolio()}
          >
            <i className="fa fa-undo"></i> Reset
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/buttonGroup.jsx